module.exports = __webpack_public_path__ + "static/media/part-08.398f1aaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-08.jpg
// module id = 941
// module chunks = 0